import React, { useState, useEffect } from "react";
import { FaSync } from "react-icons/fa";

export default function Captcha({ onCaptchaSolve }) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState(0);

  // Map numbers to their word equivalents
  const numberWords = {
    1: "One",
    2: "Two",
    3: "Three",
    4: "Four",
    5: "Five",
    6: "Six",
    7: "Seven",
    8: "Eight",
    9: "Nine",
    10: "Ten",
  };

  // Function to randomly return either the number or its word equivalent
  const getRandomNumberOrWord = (num) => {
    const useWord = Math.random() > 0.5; // Randomly decide if it should be a word or a number
    return useWord ? numberWords[num] : num;
  };

  // Custom function to perform arithmetic operations
  const calculate = (num1, num2, operation) => {
    switch (operation) {
      case "+":
        return num1 + num2;
      case "*":
        return num1 * num2;
      default:
        throw new Error("Invalid operation");
    }
  };

  // Function to generate a new captcha
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const operations = ["+", "*"];
    const randomOperation =
      operations[Math.floor(Math.random() * operations.length)];

    // Get either word or number for num1 and num2
    const num1Display = getRandomNumberOrWord(num1);
    const num2Display = getRandomNumberOrWord(num2);

    let questionText = `${num1Display} ${randomOperation} ${num2Display}`;
    let calculatedAnswer = calculate(num1, num2, randomOperation); // Calculate the correct answer

    setQuestion(questionText);
    setCorrectAnswer(calculatedAnswer);
    setAnswer(""); // Clear the input field
    onCaptchaSolve(false); // Reset validation when captcha refreshes
  };

  // Initialize captcha on component mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Handle captcha input change
  const handleCaptchaChange = (e) => {
    setAnswer(e.target.value);
  };

  // Validate captcha when the user moves out of the input field (on blur)
  const validateCaptcha = () => {
    if (parseInt(answer) === correctAnswer) {
      onCaptchaSolve(true);
    } else {
      onCaptchaSolve(false);
      generateCaptcha(); // Regenerate captcha if incorrect
    }
  };

  return (
    <div className="mt-4">
      <label className="text-lg font-medium font-custom text-skin-base">
        Captcha
      </label>
      <div className="flex items-center space-x-4 font-custom text-skin-base">
        <span>{question} =</span>
        <input
          type="number"
          value={answer}
          onChange={handleCaptchaChange}
          onBlur={validateCaptcha}
          className="w-24 border-b border-blue-300 p-2 mt-1 bg-transparent font-custom text-skin-base"
          placeholder="Answer"
          required
        />
        <FaSync
          onClick={generateCaptcha} // Refresh the captcha when clicked
          className="ml-4 cursor-pointer text-gray-500 hover:text-gray-700"
        />
      </div>
    </div>
  );
}
